export const EXPIRED_TOKEN = 'Woops, your token has expired. Please login again.'
export const SESSION_CHECK_FAILED =
  'No hemos podido comprobar tu sesión. Vuelve a intentarlo en unos segundos.'
export const WHOOPS = 'Woops, ha habido algún error.'
export const SUCCESSFUL_UPDATE_RESET = 'Reset actualizado con éxito'
export const SUCCESSFUL_UPDATE_DEVICE_NAME = 'Nombre de dispositivo actualizado con éxito'
export const SUCCESSFUL_UPDATED_USER_LIMIT = 'Límite actualizado con éxito'
export const SUCCESSFUL_UPDATED_USER_API_SERVICE_LIMIT = 'Límite de API actualizado con éxito'
